<template>
    <view-card headline="실측기본정보" :disabled="!isAdmin">
        <v-row>
            <v-col class="py-0">
                <div class="caption">거주형태</div>
                <v-radio-group v-model="measurementInfo.isManned" class="mt-0" row>
                    <v-radio label="입주전" :value="false" class="mr-4" />
                    <v-radio label="거주중" :value="true" />
                </v-radio-group>
            </v-col>
        </v-row>
        <v-row>
            <v-datetime-field v-model="measurementInfo.measureAt" @setDate="(date) => (measurementInfo.measureAt = date)" label="실측일" :hideDetails="false" />
        </v-row>
        <v-row>
            <v-datetime-field v-model="measurementInfo.orderAt" @setDate="(date) => (measurementInfo.orderAt = date)" label="예상발주일" :hideDetails="false" />
        </v-row>
        <v-row>
            <v-datetime-field v-model="measurementInfo.furnitureAt" @setDate="(date) => (measurementInfo.furnitureAt = date)" label="가구시공일" :hideDetails="false" />
        </v-row>
        <v-row>
            <v-datetime-field v-model="measurementInfo.moveAt" @setDate="(date) => (measurementInfo.moveAt = date)" label="청소/이사일" :hideDetails="false" />
        </v-row>
        <v-row>
            <v-col class="py-0">
                <v-text-field v-model="measurementInfo.totalAmount" type="number" label="최종금액" placeholder=" " hide-details />
            </v-col>
        </v-row>
        <v-card-actions slot="actions" class="pt-0 px-4 pb-4">
            <v-row justify="end">
                <v-col cols="auto" class="py-0">
                    <v-btn small color="primary" @click="$emit('clickSave', { measurementInfo })">저장</v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </view-card>
</template>
<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import ViewCardColumn from "../dumb/view-card-column.vue";
import ViewCardRow from "../dumb/view-card-row.vue";
import viewCard from "../dumb/view-card.vue";
import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
export default {
    components: { viewCard, ViewCardRow, ViewCardColumn, VDateField, VDatetimeField },
    props: {
        value: { type: Object, default: null },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            measurementInfo: {},
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.measurementInfo = JSON.parse(JSON.stringify(this.value));
        },
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>
